import { render, staticRenderFns } from "./questionJudge.vue?vue&type=template&id=afd85772&scoped=true"
import script from "./questionJudge.vue?vue&type=script&lang=js"
export * from "./questionJudge.vue?vue&type=script&lang=js"
import style0 from "./questionJudge.vue?vue&type=style&index=0&id=afd85772&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd85772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afd85772')) {
      api.createRecord('afd85772', component.options)
    } else {
      api.reload('afd85772', component.options)
    }
    module.hot.accept("./questionJudge.vue?vue&type=template&id=afd85772&scoped=true", function () {
      api.rerender('afd85772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/questionType/questionJudge.vue"
export default component.exports